import qs from 'qs'

import Api from '@/lib/api'

export default {
    namespaced: true,
    state: {
        currentItem: {}
    },
    mutations: {
        setCurrentItem (state, payload) {
          
            state.currentItem = payload
        }
    },
    actions: {
        getItem ({ commit }, payload) {
           
            return Api().get(`${payload.path}/${payload.id}`).then((response) => {
                
                commit('setCurrentItem', response.data.result)
            })
        },
        update ({ commit }, { path, id, data }) {
            const dataEncoded = qs.stringify(data)

            return Api().put(`${path}/${id}`, dataEncoded).then((response) => {
                commit('setCurrentItem', response.data.result)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/items.js